import { render, staticRenderFns } from "./ProductInvoiceDetail.vue?vue&type=template&id=393b0a3c&"
import script from "./ProductInvoiceDetail.vue?vue&type=script&lang=js&"
export * from "./ProductInvoiceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports